import React, { useEffect, useState } from 'react';
import { Col, Grid, Row, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'
import { IconSVG, ViewMR } from '../../Icons/Icons';
import { ModalData } from '../../Modals/ModalData';
import { ErrorMessage, Formik } from 'formik';
import { ControlLabel, FormControl } from 'react-bootstrap';
import { FormErrorMessage } from '../../Validations/FormValidationErrors';
import { SnomedPicker } from '../../CustomControls/SnomedPicker';
import { snomedExpressions } from '../../../variables/Enums';
import { groupValidations } from './GroupValidations';
import { Add, Copy, Down, Edit, Save, Remove, Up, View } from '../../Icons/Icons';
import { Tooltip } from "../../Utils/Tooltips";
import { ProtocolPicker } from '../../CustomControls/ProtocolPicker';

const DuplicateGroup = ({ group, onCreate }) => {
    const [copyGroup, setCopyGroup] = useState(null);

    const { t } = useTranslation();

    const [isShowing, setIsShowing] = useState(false);

    useEffect(() => {
        const groupCopy = { ...group }
        groupCopy.name = `${group.name}-Copy`;
        setCopyGroup(groupCopy)
    }, [group]);
  
    const handleOnClose = () => {
        setIsShowing(false);
    }

    const handleCreate = (group, actions) => {
        const newGroup = {
            name: group.name,
            description: group.description,
            groupPatientLimit: group.groupPatientLimit,
            patientLimit: group.patientLimit,
            protocolIds: group.groupsProtocols.map(protocol => protocol.protocolId),
            specialties: group.groupsSpecialties.map(groupsSpecialties => ({
                conceptId: groupsSpecialties.conceptId,
                description: groupsSpecialties.description
            })),
        };
        
        onCreate(newGroup)
    };

    const protocolsForPicker = group.groupsProtocols.map(groupProtocol => {
        // Retornamos un nuevo objeto que solo tiene los datos que el ProtocolPicker necesita.
        return {
            fullTitle: groupProtocol.protocol.fullTitle,
            id: groupProtocol.protocol.id,
            protocolNumber: groupProtocol.protocol.protocolNumber,
            speciality: groupProtocol.protocol.speciality,
            status: groupProtocol.protocol.status,
            title: groupProtocol.protocol.title,
        };
    });



    return (
        <>

            <Tooltip tooltip={t("protocols.groups.actionCopy")} id={"tooltipconfig-" + group.id}>
                <button onClick={() => { setIsShowing(true) }} className="btn-table-actions">
                    <Copy />
                </button>
            </Tooltip>
            <ModalData
                isShowing={isShowing}
                hide={handleOnClose}
                title="Duplicar Grupo"
                size="medium"
                className=""
            >
                <Formik
                    onSubmit={handleCreate}
                    validationSchema={groupValidations}
                    initialValues={copyGroup}
                >
                    {props => (
                        <form onSubmit={props.handleSubmit}>
                            <Col >
                                <div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.name")}</ControlLabel>
                                        <FormControl type="text" name='name' value={props.values?.name} onChange={props.handleChange} onBlur={props.handleBlur} autoComplete="off" />
                                        <ErrorMessage name="name" component={FormErrorMessage} />
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.description")}</ControlLabel>
                                        <FormControl componentClass="textarea" name='description' value={props.values?.description} onChange={props.handleChange} onBlur={props.handleBlur} autoComplete="off" />
                                        <ErrorMessage name="description" component={FormErrorMessage} />
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.patientLimit")}</ControlLabel>
                                        <FormControl type="number" name='patientLimit' value={props.values?.patientLimit} onChange={props.handleChange} onBlur={props.handleBlur} autoComplete="off" />
                                        <ErrorMessage name="patientLimit" component={FormErrorMessage} />
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.groupPatientLimit")}</ControlLabel>
                                        <FormControl type="number" name='groupPatientLimit' value={props.values?.groupPatientLimit} onChange={props.handleChange} onBlur={props.handleBlur} autoComplete="off" />
                                        <ErrorMessage name="groupPatientLimit" component={FormErrorMessage} />
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.specialties")}</ControlLabel>
                                        <div>
                                            <SnomedPicker
                                                defaultSelected={props.values.groupsSpecialties ? props.values.groupsSpecialties : []}
                                                id="specialties"
                                                value={props.values.groupsSpecialties}
                                                name="groupsSpecialties"
                                                placeholder={t("commons.search")}
                                                onChange={props.setFieldValue}
                                                onBlur={props.setFieldTouched}
                                                conceptId={snomedExpressions.Especialidades}
                                                multiple={true}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <ControlLabel>{t("protocols.groups.groupProtocols")}</ControlLabel>
                                        <ProtocolPicker
                                            defaultSelected={protocolsForPicker ? protocolsForPicker : protocolsForPicker}
                                            id="protocol"
                                            value={protocolsForPicker}
                                            name="groupsProtocols"
                                            multiple={true}
                                            placeholder={t("filters.protocol")}
                                            onChange={(name, selectedOptions) => {
                                                const selectedIds = selectedOptions?.map(option => option.id);
                                                props.setFieldValue(name, selectedIds);
                                            }}
                                        />
                                    </div>
                                    <hr />
                                    <Button type="submit" className="btn btn-success btn-primary btn-right" disabled={props.isSubmitting}><Save />{t("buttons.save")}</Button>
                                    <Button type="button" className="btn " onClick={handleOnClose} >{t("buttons.cancel")}</Button>
                                </div>
                            </Col>
                        </form>
                    )}
                </Formik>
            </ModalData>
        </>

    );
};

export default DuplicateGroup;